const initialState = {
    statusShow: false,
    origin: 'start-app',
};
const modalSelectBaseMarket = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_SELECT_BASE_MARKET':
            return {...state, statusShow: true,origin: action.origin};
        case 'CLOSE_MODAL_SELECT_BASE_MARKET':
            return {...state, statusShow: false};
        default:
            return state;
    }
};

export default modalSelectBaseMarket;
